module.exports = __webpack_public_path__ + "img/paypal.37f9e1fe.svg";